<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="8" >
            <a-form-item :label="$t('label.contractCode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled='isCodeDisabled' v-decorator="['code', validatorRules.code]" :placeholder="$t('label.pleaseEnterTheContractCode')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="合同描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['name', validatorRules.name]" placeholder="请输入合同描述"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.batchNo')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['breedBatchCode',validatorRules.breedBatchCode]" placeholder="批次管理中生成"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="合同大类" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['conCategory']" :trigger-change="true" dictCode="sfsbzht" placeholder="请选择合同大类"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="合同小类" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['conType']" :trigger-change="true" dictCode="htfl" placeholder="请选择合同小类"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="甲方公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list"  @change="handlePaDeptCodeChange" v-decorator="['paCompanyCode',validatorRules.paCompanyCode]" :trigger-change="true" dictCode="sys_depart,depart_name,org_code,org_category='1' and del_flag='0'" placeholder="请选择甲方公司"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="甲方部门" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['paDeptCode',validatorRules.paDeptCode]" :trigger-change="true" :dictCode="dictPaDeptCode" placeholder="请选择甲方部门"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="乙方养户" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['pbFarmerCode',validatorRules.pbFarmerCode]" :trigger-change="true" dictCode="efs_md_farmer,name,code" placeholder="请选择乙方养户"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="合同开始日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择合同开始日期" v-decorator="['conStartDate',validatorRules.conEndDate]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="合同结束日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择合同结束日期" v-decorator="['conEndDate',validatorRules.conEndDate]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.cooperationModel')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" @change="handleCooperModeChange" v-decorator="['cooperMode',validatorRules.cooperMode]" :trigger-change="true" dictCode="hzms" :placeholder="$t('label.pleaseSelectTheCooperationMode')" />
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="再次合作模式" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['reCooperMode',validatorRules.reCooperMode]" :trigger-change="true" dictCode="hzms" placeholder="请选择再次合作模式"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="紧急程度" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['urgentDegree',validatorRules.urgentDegree]" :trigger-change="true" dictCode="jjcd" placeholder="请选择紧急程度"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="合同文本" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['contractFileUrl',validatorRules.contractFileUrl]" placeholder="请输入合同文本"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="签订日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择签订日期" v-decorator="['partyBSignDate', {'initialValue': initPartyBSignDate, rules: validatorRules.partyBSignDate.rules}]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <!--<a-col :span="8" >
            <a-form-item label="重量合计" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['totalWeight',validatorRules.totalWeight]" placeholder="请输入重量合计" style="width: 94%"/> 斤
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="单价" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['unitPrice',validatorRules.unitPrice]" placeholder="请输入单价 元/斤" style="width: 87%"/> 元/斤
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="税率" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['taxRate',validatorRules.taxRate]" dictCode="TaxRate" placeholder="请选择税率" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="价税合计" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number @change="totalWithTaxChange" v-decorator="['totalWithTax',validatorRules.totalWithTax]" placeholder="请输入价税合计" style="width: 94%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="价税合计·大写" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['totalWithTaxCn',validatorRules.totalWithTaxCn]" placeholder="请输入价税合计(大写)" style="width: 100%"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="不含税合计" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number @change="totalExclTaxChange" v-decorator="['totalExclTax',validatorRules.totalExclTax]" placeholder="请输入不含税合计" style="width: 94%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="不含税合计·大写" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['totalExclTaxCn',validatorRules.totalExclTaxCn]" placeholder="请输入不含税合计(大写)" style="width: 100%"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="税额合计" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number @change="totalTaxChange" v-decorator="['totalTax',validatorRules.totalTax]" placeholder="请输入税额合计" style="width: 94%"/> 元
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="税额合计·大写" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['totalTaxCn',validatorRules.totalTaxCn]" placeholder="请输入税额合计(大写）" style="width: 100%"></a-input>
            </a-form-item>
          </a-col>-->
          <a-col :span="8" >
            <a-form-item label="付款说明" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['payTerm']" placeholder="请输入付款说明"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="特殊扣款约定" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['withholdTerm']" placeholder="请输入特殊扣款约定"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.applicant')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                :triggerChange="true"
                dictCode="sys_user,realname,username,del_flag = '0'"
                v-decorator="['applicant', {'initialValue': initApplicant, rules: validatorRules.applicant.rules}]"
              />
            </a-form-item>
          </a-col>
         <!-- <a-col :span="8" >
            <a-form-item label="创建日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date disabled v-decorator="['createTime']" :trigger-change="true" style="width: 100%"></j-date>
            </a-form-item>
          </a-col>-->
          <a-col :span="8" >
            <a-form-item label="会签要点" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['signKeyPoint',validatorRules.signKeyPoint]" rows="4" placeholder="请输入会签要点"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.remarks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea v-decorator="['remarks']" rows="4" :placeholder="$t('label.pleaseEnterANote')"></a-textarea>
            </a-form-item>
          </a-col>
         <!-- <a-col :span="6" >
            <a-form-item label="是否有效" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['validFlag',{'initialValue': 'Y'}]" :trigger-change="true" dictCode="sfyx" placeholder="请选择是否有效"/>
            </a-form-item>
          </a-col>-->
          <a-col :span="8" >
            <a-form-item v-has="'conVersion'" label="版本号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['conVersion']" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item v-has="'approvalStatus'" label="审核状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['approvalStatus']" placeholder="请输入审核状态"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item v-has="'lastApprover'"  label="最后审批人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['lastApprover']" placeholder="请输入最后审批人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item v-has="'lastApproveTime'"  label="最后审批时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择最后审批时间" v-decorator="['lastApproveTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
      <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane tab="合同明细" :key="refKeys[0]" :forceRender="true">
        <efs-md-contract-detail-form ref="efsMdContractDetailForm" @validateError="validateError" :disabled="formDisabled"></efs-md-contract-detail-form>
      </a-tab-pane>

<!--      <a-tab-pane tab="合同甲方信息" :key="refKeys[1]" :forceRender="true">-->
<!--        <efs-md-contract-A-sign-info-form ref="efsMdContractASignInfoForm" @validateError="validateError" :disabled="formDisabled"></efs-md-contract-A-sign-info-form>-->
<!--      </a-tab-pane>-->

<!--      <a-tab-pane tab="合同乙方信息" :key="refKeys[2]" :forceRender="true">-->
<!--        <efs-md-contract-B-sign-info-form ref="efsMdContractBSignInfoForm" @validateError="validateError" :disabled="formDisabled"></efs-md-contract-B-sign-info-form>-->
<!--      </a-tab-pane>-->

    </a-tabs>
  </a-spin>
</template>

<script>

  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { FormTypes,getRefPromise } from '@/utils/JEditableTableUtil'
  import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  import { VALIDATE_NO_PASSED, validateFormAndTables } from '@/utils/JEditableTableUtil'
  import { validateDuplicateValue, validateDuplicateValueTwoCol,convertUppercase } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import EfsMdContractDetailForm from './EfsMdContractDetailForm.vue'
  // import efsMdContractASignInfoForm from './EfsMdContractSignInfoForm.vue'
  // import efsMdContractBSignInfoForm from './EfsMdContractSignInfoForm.vue'

  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import {getCurrentUser, getMmListNoPage} from '@/api/api'
  import moment from "moment"


  export default {
    name: 'EfsMdContractForm',
    mixins: [JEditableTableMixin],
    components: {
      JFormContainer,
      EfsMdContractDetailForm,
      JDate,
      JDictSelectTag,
    },
    data() {
      return {
        isCodeDisabled: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        validatorRules: {
          code: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheContractCode')},
              { validator: (rule, value, callback) => validateDuplicateValue('efs_md_contract', 'code', value, this.model.id, callback)},
            ]
          },
          name: {
            rules: [
              { required: true, message: '请输入合同描述!'},
            ]
          },
          paCompanyCode: {
              rules: [
                  { required: true, message: '请选择甲方公司!'},
              ]
          },
            paDeptCode: {
                rules: [
                    { required: true, message: '请选择甲方部门!'},
                ]
            },
            pbFarmerCode: {
                rules: [
                    { required: true, message: '请选择乙方养户!'},
                ]
            },
            conStartDate: {
                rules: [
                    { required: true, message: '请选择合同开始日期!'},
                ]
            },
            conEndDate: {
                rules: [
                    { required: true, message: '请选择合同结束日期!'},
                ]
            },
            cooperMode: {
                rules: [
                    { required: true, message: '请选择合作模式!'},
                ]
            },
            reCooperMode: {
                rules: [
                    { required: true, message: '请选择再次合作模式!'},
                ]
            },
            urgentDegree: {
                rules: [
                    { required: true, message: '请选择紧急程度!'},
                ]
            },
            contractFileUrl: {
                rules: [
                    { required: true, message: '请输入合同文本!'},
                ]
            },
            partyBSignDate: {
                rules: [
                    { required: true, message: '请选择签订日期!'},
                ]
            },
            /*totalWeight: {
                rules: [
                    { required: true, message: '请输入重量合计!'},
                ]
            },
            unitPrice: {
                rules: [
                    { required: true, message: this.$t('label.pleaseEnterTheUnitPrice')},
                ]
            },
            totalWithTax: {
                rules: [
                    { required: true, message: '请输入价税合计!'},
                    {pattern: /^(([1-9][0-9]*)|([0]\.\d{0,2}|[1-9][0-9]*\.\d{0,2}))$/ ,message: "只能输入两位小数!"},
                ]
            },
            totalWithTaxCn: {
                rules: [
                    { required: true, message: '请输入价税合计(大写)!'},
                ]
            },
            totalExclTax: {
                rules: [
                    { required: true, message: '请输入不含税合计!'},
                    {pattern: /^(([1-9][0-9]*)|([0]\.\d{0,2}|[1-9][0-9]*\.\d{0,2}))$/ ,message: "只能输入两位小数!"},
                ]
            },
            totalExclTaxCn: {
                rules: [
                    { required: true, message: '请输入不含税合计(大写)!'},
                ]
            },
            totalTax: {
                rules: [
                    { required: true, message: '请输入税额合计!'},
                    {pattern: /^(([1-9][0-9]*)|([0]\.\d{0,2}|[1-9][0-9]*\.\d{0,2}))$/ ,message: "只能输入两位小数!"},
                ]
            },
            totalTaxCn: {
                rules: [
                    { required: true, message: '请输入税额合计(大写)!'},
                ]
            },*/
            applicant: {
                rules: [
                    { required: true, message: '请选择申请人!'},
                ]
            },
            signKeyPoint: {
                rules: [
                    { required: true, message: '请输入会签要点!'},
                ]
            },
           /* taxRate: {
                rules: [
                    { required: true, message: '请选择税率!'},
                ]
            },*/
        },
        refKeys: ['efsMdContractDetail',],
        tableKeys:[],
        activeKey: 'efsMdContractDetail',
        // 合同明细
        efsMdContractDetailTable: {
          loading: false,
          dataSource: [],
          columns: [
          ]
        },
        // 合同甲方信息
        url: {
          add: "/contractManage/efsMdContract/add",
          edit: "/contractManage/efsMdContract/edit",
          queryById: "/contractManage/efsMdContract/queryById",
          efsMdContractDetail: {
            list: '/contractManage/efsMdContract/queryEfsMdContractDetailByMainId'
          },
        },
        initApplicant: null,
        initPartyBSignDate: moment(new Date()).format('YYYY-MM-DD'),
          dictPaDeptCode:"",
      }
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：false流程表单 true普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
      getCurrentUser().then((res) => {
        if (res.success) {
          this.initApplicant = res.result.username;
        }
      });
    },
    methods: {
      addBefore(){
        this.form.resetFields()
        this.$refs.efsMdContractDetailForm.clearFormData()
      },
      getAllTable() {
        return new Promise(resolve => {
          resolve([]);
        })
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter(record) {
        let fieldval = pick(this.model,'code','name','breedBatchCode','conVersion','conCategory','conType','paCompanyCode','paDeptCode','pbFarmerCode','conStartDate','conEndDate','cooperMode','reCooperMode','urgentDegree','contractFileUrl','partyBSignDate','payTerm','withholdTerm','applicant','signKeyPoint','remarks','approvalStatus','lastApprover','lastApproveTime','validFlag','createTime')
        this.model = Object.assign({}, record);

        //编辑页面禁止修改编码
        if(this.model.id){
          this.isCodeDisabled = true;
          this.handleCooperModeChange(this.model.cooperMode);
          this.handlePaDeptCodeChange(this.model.paCompanyCode);
        }else{
          this.isCodeDisabled = false;
            this.handleCooperModeChange("undefined");
            this.model.paDeptCode="";
        }

        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
          this.$refs.efsMdContractDetailForm.initFormData(this.url.efsMdContractDetail.list,this.model.id)
                  })
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
        }
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          efsMdContractDetailList: this.$refs.efsMdContractDetailForm.getFormData(),

        }
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          })
        }
      },
      validateError(msg){
        this.$message.error(msg)
      },
     popupCallback(row){
       this.form.setFieldsValue(pick(row,'code','name','breedBatchCode','conVersion','conCategory','conType','paCompanyCode','paDeptCode','pbFarmerCode','conStartDate','conEndDate','cooperMode','reCooperMode','urgentDegree','contractFileUrl','partyBSignDate','payTerm','withholdTerm','applicant','signKeyPoint','remarks','approvalStatus','lastApprover','lastApproveTime','validFlag','createTime'))
     },
        /** 确定按钮点击事件 */
        handleOk() {
            if(this.$refs.efsMdContractDetailForm.getFormData().length==0){
                return;
            }
            /** 触发表单验证 */
            this.getAllTable().then(tables => {
                /** 一次性验证主表和所有的次表 */
                return validateFormAndTables(this.form, tables)
            }).then(allValues => {
                if (typeof this.classifyIntoFormData !== 'function') {
                    throw this.throwNotFunction('classifyIntoFormData')
                }
                let formData = this.classifyIntoFormData(allValues)
                // 发起请求
                return this.request(formData)
            }).catch(e => {
                if (e.error === VALIDATE_NO_PASSED) {
                    // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
                    this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
                } else {
                    console.error(e)
                }
            })
        },
        handleCooperModeChange(value) {
            this.$refs.efsMdContractDetailForm.cooperModeChange(value);
        },
        handlePaDeptCodeChange(value) {
            this.dictPaDeptCode = "sys_depart,depart_name,org_code,org_code like '" + value + "*' and org_category='2' and del_flag='0'";
           this.model.paDeptCode="";
            this.$nextTick(() => {
                this.form.setFieldsValue(pick(this.model, 'paDeptCode'))
            })
        },
        /*totalWithTaxChange(money){
                  let totalWithTaxCn=convertUppercase(money);
                  this.form.setFieldsValue({
                      "totalWithTaxCn": totalWithTaxCn
                  });

        },
        totalExclTaxChange(money){
            let totalExclTaxCn=convertUppercase(money);
            this.form.setFieldsValue({
                "totalExclTaxCn": totalExclTaxCn
            });
        },
        totalTaxChange(money){
            let totalTaxCn=convertUppercase(money);
            this.form.setFieldsValue({
                "totalTaxCn": totalTaxCn
            });
        },*/
    }
  }
</script>

<style scoped>
</style>